import ArticleStructuredData from '@components/app/ListingPage/Author'
import { TrialListingPage } from '@components/app/ListingPage/TrialListingPage.client'
import { TrialApplicationLayout } from '@components/primitives/Layout/PatientLayouts.client'
import { type LegacyTrialPageProps } from './getLegacyTrialListingPageProps'

export const LegacyTrialListingPage = ({
  legacyTrialPageProps,
}: {
  legacyTrialPageProps: LegacyTrialPageProps
}) => {
  return (
    <>
      <TrialApplicationLayout>
        <TrialListingPage {...legacyTrialPageProps} />
      </TrialApplicationLayout>
      <ArticleStructuredData trial={legacyTrialPageProps.trial} />
    </>
  )
}
